import React, { useState, useEffect } from "react";
import {
  Divider,
  Grid,
  makeStyles,
  Paper,
  Typography,
} from "@material-ui/core";
import NumberFormat from "react-number-format";
import { connect } from "react-redux";
import styles from "../../../styles/global-styles";
import {
  getAccesoryTotalDiscounts,
  getMovileTotalDiscounts,
  getSubTotalCost,
  getTotalCost,
  getTotalDiscount,
  showChipLabelInResume,
  showProductLabelInResume,
} from "./utils-shoppingCart";
import { countItemsIncart } from "../inventory/utils.inventory";
import InfoProductsShoppingCart from "./InfoProductsShoppingCart";
import InfoChipsProduct from "./InfoChipsProduct";

const useStyles = makeStyles(() => ({
  resumePaper: {
    height: "auto",
    width: "auto",
    background: "white",
    marginTop: 50,
  },
  title: {
    fontWeight: 700,
    color: "#1C2668",
    opacity: 0.5,
    fontSize: 24,
    padding: 14,
  },
  productTitle: {
    marginLeft: 20,
    marginBottom: 5,
    marginTop: 15,
    fontWeight: 400,
  },
  body: styles.body,
  discountLabel: {
    fontWeight: 800,
    color: "#1C2668",
    opacity: 0.6,
    fontSize: 16,
    marginLeft: 25,
    marginTop: 0,
  },
}));

const CartResume = ({ shoppingCart: { cart }, chipNumbers, itemRemoved }) => {
  const classes = useStyles();
  const productTitle = {
    marginLeft: 20,
    marginBottom: 5,
    marginTop: 15,
    fontWeight: 400,
  };

  const [counterProductsArray, setCounterProductsArray] = useState([]);

  useEffect(() => {
    // const counterObject = countItemsIncart(cart);
    // console.log("counterProductsArray", counterObject);
    setCounterProductsArray(countItemsIncart(cart));
  }, [Object.keys(cart).length]);

  useEffect(() => {
    /** JSON.stringify works for listen
     * any change on cart
     * */
    getTotalDiscount(cart, counterProductsArray);
  }, [JSON.stringify(Object.values(cart))]);

  return (
    <Paper className={classes.resumePaper}>
      <Typography variant="h4" component="h4" className={classes.title}>
        Resumen
      </Typography>

      {counterProductsArray.length > 0 && (
        <>
          {showProductLabelInResume(counterProductsArray, "1") && (
            <Typography className={classes.body} style={productTitle}>
              Equipos movil
            </Typography>
          )}
          <InfoProductsShoppingCart
            counterProductsArray={counterProductsArray}
            productTypeId="1"
          />
          {counterProductsArray.some((item) => item.productTypeId === "1") && (
            <>
              <p className={classes.discountLabel}>
                Descuento ${getMovileTotalDiscounts(cart)}
              </p>
            </>
          )}

          {showProductLabelInResume(counterProductsArray, "2") && (
            <Typography style={productTitle} className={classes.body}>
              Accesorios
            </Typography>
          )}
          <InfoProductsShoppingCart
            counterProductsArray={counterProductsArray}
            productTypeId="2"
          />
          {counterProductsArray.some((item) => item.productTypeId === "2") && (
            <>
              <p className={classes.discountLabel}>
                Descuento ${getAccesoryTotalDiscounts(cart)}
              </p>
            </>
          )}

          {showProductLabelInResume(counterProductsArray, "4") && (
            <Typography style={productTitle} className={classes.body}>
              Tarjetas de saldo
            </Typography>
          )}
          <InfoProductsShoppingCart
            counterProductsArray={counterProductsArray}
            productTypeId="4"
          />

          {showProductLabelInResume(counterProductsArray, "5") && (
            <Typography className={classes.body} style={productTitle}>
              Traspaso de saldo
            </Typography>
          )}
          <InfoProductsShoppingCart
            counterProductsArray={counterProductsArray}
            productTypeId="5"
          />

          {showProductLabelInResume(counterProductsArray, "6") && (
            <Typography className={classes.body} style={productTitle}>
              Plan tarifario
            </Typography>
          )}
          <InfoProductsShoppingCart
            counterProductsArray={counterProductsArray}
            productTypeId="6"
          />
        </>
      )}

      {showChipLabelInResume(cart) && (
        <Typography style={productTitle} className={classes.body}>
          Chips
        </Typography>
      )}

      {
        <InfoChipsProduct
          cart={cart}
          itemRemoved={itemRemoved}
          chipNumbers={chipNumbers}
        />
      }

      <div
        style={{
          margin: "30px 0px -20px 20px",
          fontWeight: 800,
        }}
        className={classes.body}
      >
        Detalle
      </div>

      <Divider style={{ marginTop: 30 }} />
      <Grid
        container
        direction="row"
        justify="space-around"
        alignItems="center"
      >
        <Grid item style={{ marginTop: 10 }}>
          <Typography variant="body1" component={"span"}>
            Subtotal ({Object.keys(cart).length} artículos)
          </Typography>
        </Grid>
        <Grid item></Grid>
        <Grid item>
          <Typography
            variant="body1"
            component={"span"}
            className={classes.body}
          >
            <NumberFormat
              value={getSubTotalCost(cart)}
              displayType={"text"}
              thousandSeparator={true}
              prefix={"$"}
            />
          </Typography>
        </Grid>

        <Grid item container style={{ marginTop: 10 }} />
        <Grid item>
          <Typography variant="body1" component={"span"}>
            Descuento total
          </Typography>
        </Grid>
        <Grid item></Grid>
        <Grid item>
          <Typography
            variant="body1"
            component={"span"}
            className={classes.body}
          >
            <NumberFormat
              value={getTotalDiscount(cart)}
              displayType={"text"}
              thousandSeparator={true}
              prefix={"$"}
            />
          </Typography>
        </Grid>

        <Grid item container style={{ marginTop: 40 }} />
        <Grid item>
          <Typography variant="body1" component={"span"}>
            Total
          </Typography>
        </Grid>
        <Grid item></Grid>
        <Grid item>
          <Typography
            variant="body1"
            component={"span"}
            className={classes.body}
          >
            <NumberFormat
              value={getTotalCost(cart)}
              displayType={"text"}
              thousandSeparator={true}
              prefix={"$"}
            />
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

const mapStateToProps = (state) => ({
  shoppingCart: state.shoppingCart,
});

export default connect(mapStateToProps)(CartResume);
